import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate } from '../../../../utils/util';
import HomeDefault from '../../../../components/HomeDefaultComponent';

const ShedArea = () => {
    const menu = () => {
        let menuItems = [];

        menuItems = [...menuItems, {
            route: '/truckkanban/registrations/Insert',
            icon: 'mdi mdi-plus-box-outline',
            text: translate('shed-area-insert', 'truck-kanban')
        }];

        menuItems = [...menuItems, {
            route: '/truckkanban/registrations/List',
            icon: 'mdi mdi-clipboard-list-outline',
            text: translate('shed-area-list', 'truck-kanban')
        }];

        return menuItems;
    };

    return (
        <HomeDefault menu={menu()} title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('registrations', 'truck-kanban') }} />
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

export default connect(mapStateToProps)(withTranslation()(ShedArea));